import React from "react";
import MUIFormControl from "@mui/material/FormControl";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import MUIFormHelperText from "@mui/material/FormHelperText";
import MUIFormLabel from "@mui/material/FormLabel";
import MUIRadio from "@mui/material/Radio";
import MUIRadioGroup from "@mui/material/RadioGroup";
import MUITooltip from "@mui/material/Tooltip";
import { extractFormFieldError } from "@sscs/utils";
import { Controller, useFormContext, } from "react-hook-form";
import { useControlSize } from "../formDense";
import { useRegisterRequiredField } from "../requiredFields";
import styles from "./radioGroup.module.scss";
function RadioGroup({ items, size, isRequired = false, orientation = "vertical", ...props }) {
    const { control } = useFormContext();
    const resolvedSize = useControlSize(size);
    useRegisterRequiredField(isRequired);
    const isDisabled = !items.some((item) => !item.disabled);
    const labelId = props.id ? `${props.id}-label` : `${props.name}-label`;
    const { errorMessage, hasError } = extractFormFieldError(props.name, props === null || props === void 0 ? void 0 : props.errors);
    return (React.createElement(MUIFormControl, null,
        props.label && (React.createElement(MUIFormLabel, { required: isRequired, disabled: isDisabled, htmlFor: props.id, id: labelId }, props.label)),
        props.helperText && (React.createElement(MUIFormHelperText, { disabled: isDisabled, className: styles["helper-text"] }, props.helperText)),
        React.createElement(Controller, { control: control, name: props.name, render: ({ field: { ref, ...field } }) => {
                var _a;
                return (React.createElement(MUIRadioGroup, { ...field, id: props.id, "aria-labelledby": labelId, name: field.name, value: (_a = field.value) !== null && _a !== void 0 ? _a : "", row: orientation === "horizontal", onChange: (event) => {
                        var _a;
                        field.onChange(event);
                        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, event);
                    }, onBlur: () => {
                        var _a;
                        field.onBlur();
                        (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props);
                    }, className: props.radioGroupClassName }, items.map((radioItem, index) => (React.createElement(ConditionalWrapper, { tooltip: radioItem.tooltip, key: radioItem.id },
                    React.createElement(React.Fragment, null,
                        React.createElement(MUIFormControlLabel, { value: radioItem.value, control: React.createElement(MUIRadio, { size: resolvedSize, id: radioItem.id, inputRef: index === 0 ? ref : undefined }), label: radioItem.label, disabled: radioItem.disabled, className: radioItem.className }),
                        radioItem.helperText && (React.createElement(MUIFormHelperText, { className: styles[`helper-${resolvedSize}`] }, radioItem.helperText)),
                        hasError && (React.createElement(MUIFormHelperText, { error: true }, errorMessage))))))));
            } })));
}
const ConditionalWrapper = ({ tooltip, children, }) => {
    return tooltip ? (React.createElement(MUITooltip, { arrow: true, title: tooltip },
        React.createElement("span", null, children))) : (children);
};
export default RadioGroup;
//# sourceMappingURL=RadioGroup.js.map